import getAttributeIconFile from './getAttributeIconFile'

// Entscheidet pro Attribut, ob es als Grafik oder als Text in die Mail geht.
//
// Regel: sobald irgendetwas an der Grafik fehlt, wird auf den Attributnamen
// zurueckgefallen. Nie ein <img> mit unbrauchbarer URL — in Apple Mail bleibt
// davon nur ein leerer Rahmen, weil WebKit den alt-Text wegschneidet, der nicht
// in die width/height-Box passt. Ein Text-Chip ist in jedem Client lesbar.
//
// Deshalb muss die Basis-URL absolut sein: E-Mail hat keinen Seitenkontext, aus
// dem ein relativer Pfad aufgeloest werden koennte.
const ABSOLUTE_URL_PATTERN = /^https?:\/\//i

const ASSETS_PATH = 'wp-content/themes/pmkino/assets-static'

const getAttributeIconData = (attr, currentCinemaUrl) => {
  if (!attr) {
    return null
  }

  // Name ist der Fallback-Text und der alt-Text; ohne ihn bliebe der Chip leer
  const name = `${attr.name || ''}`.trim() || `${attr.id || ''}`.trim()
  const base = `${currentCinemaUrl || ''}`.trim()
  const icon = ABSOLUTE_URL_PATTERN.test(base) ? getAttributeIconFile(attr.id) : null

  if (!icon) {
    return { ...attr, name: name, iconUrl: null, iconWidth: undefined, iconHeight: undefined }
  }

  const baseWithoutSlash = base.replace(/\/+$/, '')

  return {
    ...attr,
    name: name,
    iconUrl: `${baseWithoutSlash}/${ASSETS_PATH}/${icon.file}`,
    iconWidth: icon.width,
    iconHeight: icon.height,
  }
}

export default getAttributeIconData
